import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { get, has, orderBy } from 'lodash';
import moment from 'moment';
import { Link } from '@bd/bdcore-named-routes';
import { SanitizeHtml, buildThumbnailUrl } from '@bd/bdcore-utilities';
import Footer from '../../components/Footer';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuAbout from '../../components/MenuAbout';
import { colors } from '../../styles';

const styles = css`
  .blogpost_detail {
    padding-top: 60px;
    padding-bottom: 90px;
    img {
      width: 100%;
      margin: 0 0 30px 0;
    }
    .blogpost_date {
      font-weight: 800;
      font-size: 13px;
      color: #8A8A8A;
      padding: 0 0 15px 0;
      margin: 0 0 15px 0;
      border-bottom: 1px solid ${colors.color3};
    }
  }
  .blogposts {
    display: block;
    position: relative;
    padding: 0 0 45px 0;
    &:after {
      content: '';
      background-color: #CFCFCF;
      width: 75px;
      height: 3px;
      bottom: 0;
      left: 0;
      display: block;
    }
    img {
      width: 100%;
      margin: 0 0 15px 0;
    }
    .blogposts_title {
      font-weight: 800;
      font-size: 16px;
      color: #000000;
      text-transform: uppercase;
      position: relative;
      margin: 0 0 15px 0;
    }
    .blogposts_date {
      font-weight: 800;
      font-size: 13px;
      color: #8A8A8A;
    }
  }
  @media (min-width: 992px) {
    .blogposts {
      &:after {
        background-color: ${colors.color1};
        width: 125px;
      }
      .blogposts_title {
        font-size: 23px;
      }
    }
  }
  .blog_sidebarHeading {
    font-weight: 800;
    color: ${colors.color1};
    font-size: 14px;
    text-transform: uppercase;
    margin: 60px 0 30px 0;
    padding: 0 0 15px 0;
    border-bottom: 1px solid ${colors.color3};
    @media (min-width: 992px) {
      margin: 0 0 30px 0;
    }
  }
`;

function BlogpostDetail({ blogpost, blogposts }) {
  return (
    <div className={styles}>
      <PageWrapper>
        <InsideHeader
          h1={`${blogpost.title}`}
          background={get(blogpost, 'logo.contentUrl')}
        />
        <MenuAbout />
        <div className="container blogpost_detail">
          <div className="row">
            <div className="col-lg-8">
              <h4 className="blogpost_date">
                {
                  has(blogpost, 'date') &&
                  moment(get(blogpost, 'date')).format('MMMM D, YYYY')
                }
              </h4>
              <div className="body" dangerouslySetInnerHTML={SanitizeHtml(get(blogpost, 'htmlbody'))} />
            </div>
            <div className="col-lg-3 ml-auto">
              <div className="blogposts">
                <h3 className="blog_sidebarHeading">Recent Posts</h3>
                {
                  orderBy(blogposts, 'date', 'desc').filter(post => post !== blogpost).slice(0, 5).map(post => (
                    <Link name="blogpost-detail" params={{ blogpostTitle: post.title }} key={post._id}>
                      <img src={buildThumbnailUrl(post.logo.contentUrl, { width: 300, height: 300 })} alt="" />
                      <h4 className="blogposts_date">
                        {
                          has(post, 'date') &&
                          moment(get(post, 'date')).format('MMMM D, YYYY')
                        }
                      </h4>
                      <h3 className="blogposts_title">{post.title}</h3>
                    </Link>
                  ))
                }
              </div>
              {/* <div className="blogpost_categories">
                <h3 className="blog_sidebarHeading">Blog Categories</h3>
              </div> */}
            </div>
          </div>
        </div>
        <Footer />
      </PageWrapper>
    </div>
  );
}

BlogpostDetail.propTypes = {
  blogpost: PropTypes.object.isRequired,
  blogposts: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData({
  blogpost: true,
  blogposts: true,
})(BlogpostDetail);



// WEBPACK FOOTER //
// ./src/pages/BlogpostDetail/index.js